import React from "react";
import { Avatar, Box, TableRow, TableCell, Typography } from "@mui/material";
import { formatPhoneNumber } from "../../../util/ValidationUtils";
import UserRoleChip from "./UserRoleChip";
import SmsIndicator from "./SmsIndicator";
import UserActionsMenu from "./UserActionsMenu";
import { getRoleChipColors, getUserInitials, ManagedUser } from "./userDisplayUtils";

interface UsersTableRowProps {
  user: ManagedUser;
  onEdit: (user: ManagedUser) => void;
  onDelete: (user: ManagedUser) => void;
  roleBasedOptions: string[];
  isBuyer?: boolean;
}

const UsersTableRow = ({ user, onEdit, onDelete, roleBasedOptions, isBuyer }: UsersTableRowProps) => {
  const canManage = roleBasedOptions.includes(user.role ?? '');
  const roleColors = getRoleChipColors(user.role);

  return (
    <TableRow hover>
      <TableCell>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
          <Avatar
            sx={{
              width: 30,
              height: 30,
              fontSize: 11,
              fontWeight: 600,
              flexShrink: 0,
              bgcolor: roleColors.bg,
              color: roleColors.color,
            }}
          >
            {getUserInitials(user)}
          </Avatar>
          <Typography variant={'body2'} color={'textPrimary'} sx={{ overflowWrap: 'anywhere' }}>
            {user.username}
          </Typography>
        </Box>
      </TableCell>
      <TableCell>
        <Typography variant={'body2'} color={'textPrimary'} noWrap>
          {`${user.firstName || ''} ${user.lastName || ''}`.trim()}
        </Typography>
      </TableCell>
      <TableCell>
        <UserRoleChip role={user.role} />
      </TableCell>
      <TableCell>
        <Typography
          variant={'body2'}
          color={'textPrimary'}
          sx={{ fontFamily: 'monospace', whiteSpace: 'nowrap' }}
        >
          {formatPhoneNumber(user.phoneNumber || '')}
        </Typography>
      </TableCell>
      {isBuyer && (
        <TableCell>
          <SmsIndicator user={user} />
        </TableCell>
      )}
      {canManage ? (
        <TableCell align={'right'}>
          <UserActionsMenu user={user} onEdit={onEdit} onDelete={onDelete} />
        </TableCell>
      ) : (
        <TableCell />
      )}
    </TableRow>
  );
};

export default UsersTableRow;
